import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParsePersNr } from '../Parsers/TEDParsePersNr';
import { TEDDisplayPersNr } from '../Displayers/TEDDisplayPersNr';

class TEDFormatPersNr implements IFormatter {
  displayer = TEDDisplayPersNr.getInstance();
  parser = TEDParsePersNr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatPersNr };
